import React from 'react';

/**
 * Renderiza el bloque DailySelectionHeader de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function DailySelectionHeader({
  v
}) {
  return React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "alignItems": "center",
      "gap": "1.111111vh"
    }
  }, v.text("\n          "), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "baseline",
      "gap": "1.111111vh",
      "flex": "none",
      "whiteSpace": "nowrap"
    }
  }, v.text("\n            "), React.createElement("h2", {
    style: {
      "margin": "0",
      "fontSize": "1.481481vh",
      "fontWeight": "600",
      "whiteSpace": "nowrap"
    }
  }, v.text("Detalle diario")), v.text("\n            "), React.createElement("span", {
    style: {
      "font": "600 1.296296vh 'IBM Plex Mono',monospace",
      "whiteSpace": "nowrap"
    }
  }, v.text(v.detTitle)), v.text("\n            "), v.text("\n          ")), v.text("\n          "), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "1.296296vh"
    }
  }, v.text("\n            "), React.createElement("div", {
    "onMouseLeave": v.dsClose,
    style: {
      "display": "flex",
      "gap": "0.740741vh"
    }
  }, React.createElement("div", {
    style: {
      "position": "relative"
    }
  }, React.createElement("button", {
    "onClick": v.dsCage.toggle,
    "onWheel": v.dsCage.wheel,
    "data-wheel-zoom": "1",
    "title": "Clic para elegir · rueda del mouse para cambiar",
    style: {
      "display": "flex",
      "flexDirection": "column",
      "alignItems": "flex-start",
      "gap": "0.092593vh",
      "minWidth": v.dsCage.w,
      "padding": "0.277778vh 2.407407vh 0.277778vh 0.925926vh",
      "position": "relative",
      "background": "rgba(3,10,22,0.6)",
      "border": "0.092593vh solid " + v.dsCage.bd,
      "borderRadius": "0.648148vh",
      "cursor": "ns-resize",
      "color": "#e4e9f0",
      "textAlign": "left"
    },
    className: "scapp-full-hover"
  }, React.createElement("span", {
    style: {
      "fontSize": "0.925926vh",
      "color": "#8793a6",
      "lineHeight": "1.1"
    }
  }, v.text("Jaula")), React.createElement("span", {
    style: {
      "font": "700 1.296296vh 'IBM Plex Mono',monospace",
      "lineHeight": "1.2",
      "whiteSpace": "nowrap"
    }
  }, v.text(v.dsCage.v)), React.createElement("span", {
    style: {
      "position": "absolute",
      "right": "0.416667vw",
      "top": "50%",
      "transform": "translateY(-50%)",
      "fontSize": "0.925926vh",
      "color": "oklch(0.66 0.19 42)"
    }
  }, v.text("▾"))), v.text("\n              "), v.dsCage.rollOn ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "position": "absolute",
      "top": "calc(100% + 0.37037vh)",
      "left": "0",
      "zIndex": "71",
      "minWidth": "100%",
      "background": "#101c2e",
      "border": "0.092593vh solid oklch(0.62 0.18 42 / 0.6)",
      "borderRadius": "0.740741vh",
      "boxShadow": "0 1.296296vh 3.148148vh rgba(0,0,0,0.55)",
      "padding": "0.37037vh",
      "display": "flex",
      "flexDirection": "column",
      "alignItems": "stretch",
      "pointerEvents": "none",
      "WebkitMaskImage": "linear-gradient(180deg,transparent 0,#000 30%,#000 70%,transparent 100%)",
      "maskImage": "linear-gradient(180deg,rgba(0,0,0,0.35) 0,#000 30%,#000 70%,rgba(0,0,0,0.35) 100%)"
    }
  }, (v.dsCage.items || []).map((o, index14) => React.createElement(React.Fragment, {
    key: index14
  }, React.createElement("div", {
    style: {
      "height": o.h,
      "display": "flex",
      "alignItems": "center",
      "justifyContent": "space-between",
      "gap": "0.925926vh",
      "padding": "0 0.925926vh",
      "borderRadius": "0.462963vh",
      "background": o.bg,
      "font": o.fw + " " + o.fs + " 'IBM Plex Mono',monospace",
      "color": o.c,
      "whiteSpace": "nowrap"
    }
  }, React.createElement("span", {}, v.text(o.l)), React.createElement("span", {
    style: {
      "font": "1.018519vh 'IBM Plex Sans',sans-serif",
      "color": "#8793a6"
    }
  }, v.text(o.s))))))) : null, v.dsCage.open ? React.createElement(React.Fragment, null, React.createElement("div", {
    "onWheel": v.stopProp,
    style: {
      "position": "absolute",
      "top": "calc(100% + 0.37037vh)",
      "left": "0",
      "zIndex": "70",
      "minWidth": "100%",
      "maxHeight": "27.777778vh",
      "overflowY": "auto",
      "background": "#101c2e",
      "border": "0.092593vh solid rgba(184,193,206,0.18)",
      "borderRadius": "0.740741vh",
      "boxShadow": "0 1.296296vh 3.148148vh rgba(0,0,0,0.55)",
      "padding": "0.37037vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.092593vh",
      "overscrollBehavior": "contain"
    }
  }, (v.dsCage.opts || []).map((o, index15) => React.createElement(React.Fragment, {
    key: index15
  }, React.createElement("button", {
    "onClick": o.go,
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "gap": "1.111111vh",
      "padding": "0.555556vh 0.925926vh",
      "border": "0",
      "borderRadius": "0.462963vh",
      "background": o.bg,
      "color": o.c,
      "cursor": "pointer",
      "font": "600 1.203704vh 'IBM Plex Mono',monospace",
      "whiteSpace": "nowrap",
      "textAlign": "left",
      "flex": "none"
    },
    className: "scapp-full-hover"
  }, React.createElement("span", {}, v.text(o.l)), React.createElement("span", {
    style: {
      "font": "1.018519vh 'IBM Plex Sans',sans-serif",
      "color": "#8793a6"
    }
  }, v.text(o.s))))))) : null), React.createElement("div", {
    style: {
      "position": "relative"
    }
  }, React.createElement("button", {
    "onClick": v.dsDay.toggle,
    "onWheel": v.dsDay.wheel,
    "data-wheel-zoom": "1",
    "title": "Clic para elegir · rueda del mouse para cambiar",
    style: {
      "display": "flex",
      "flexDirection": "column",
      "alignItems": "flex-start",
      "gap": "0.092593vh",
      "minWidth": v.dsDay.w,
      "padding": "0.277778vh 2.407407vh 0.277778vh 0.925926vh",
      "position": "relative",
      "background": "rgba(3,10,22,0.6)",
      "border": "0.092593vh solid " + v.dsDay.bd,
      "borderRadius": "0.648148vh",
      "cursor": "ns-resize",
      "color": "#e4e9f0",
      "textAlign": "left"
    },
    className: "scapp-full-hover"
  }, React.createElement("span", {
    style: {
      "fontSize": "0.925926vh",
      "color": "#8793a6",
      "lineHeight": "1.1"
    }
  }, v.text("Fecha")), React.createElement("span", {
    style: {
      "font": "700 1.296296vh 'IBM Plex Mono',monospace",
      "lineHeight": "1.2",
      "whiteSpace": "nowrap"
    }
  }, v.text(v.dsDay.v)), React.createElement("span", {
    style: {
      "position": "absolute",
      "right": "0.416667vw",
      "top": "50%",
      "transform": "translateY(-50%)",
      "fontSize": "0.925926vh",
      "color": "oklch(0.66 0.19 42)"
    }
  }, v.text("▾"))), v.text("\n              "), v.dsDay.rollOn ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "position": "absolute",
      "top": "calc(100% + 0.37037vh)",
      "left": "0",
      "zIndex": "71",
      "minWidth": "100%",
      "background": "#101c2e",
      "border": "0.092593vh solid oklch(0.62 0.18 42 / 0.6)",
      "borderRadius": "0.740741vh",
      "boxShadow": "0 1.296296vh 3.148148vh rgba(0,0,0,0.55)",
      "padding": "0.37037vh",
      "display": "flex",
      "flexDirection": "column",
      "alignItems": "stretch",
      "pointerEvents": "none",
      "WebkitMaskImage": "linear-gradient(180deg,transparent 0,#000 30%,#000 70%,transparent 100%)",
      "maskImage": "linear-gradient(180deg,rgba(0,0,0,0.35) 0,#000 30%,#000 70%,rgba(0,0,0,0.35) 100%)"
    }
  }, (v.dsDay.items || []).map((o, index16) => React.createElement(React.Fragment, {
    key: index16
  }, React.createElement("div", {
    style: {
      "height": o.h,
      "display": "flex",
      "alignItems": "center",
      "justifyContent": "space-between",
      "gap": "0.925926vh",
      "padding": "0 0.925926vh",
      "borderRadius": "0.462963vh",
      "background": o.bg,
      "font": o.fw + " " + o.fs + " 'IBM Plex Mono',monospace",
      "color": o.c,
      "whiteSpace": "nowrap"
    }
  }, React.createElement("span", {}, v.text(o.l)), React.createElement("span", {
    style: {
      "font": "1.018519vh 'IBM Plex Sans',sans-serif",
      "color": "#8793a6"
    }
  }, v.text(o.s))))))) : null, v.dsDay.open ? React.createElement(React.Fragment, null, React.createElement("div", {
    "onWheel": v.stopProp,
    style: {
      "position": "absolute",
      "top": "calc(100% + 0.37037vh)",
      "left": "0",
      "zIndex": "70",
      "minWidth": "100%",
      "maxHeight": "27.777778vh",
      "overflowY": "auto",
      "background": "#101c2e",
      "border": "0.092593vh solid rgba(184,193,206,0.18)",
      "borderRadius": "0.740741vh",
      "boxShadow": "0 1.296296vh 3.148148vh rgba(0,0,0,0.55)",
      "padding": "0.37037vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.092593vh",
      "overscrollBehavior": "contain"
    }
  }, (v.dsDay.opts || []).map((o, index17) => React.createElement(React.Fragment, {
    key: index17
  }, React.createElement("button", {
    "onClick": o.go,
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "gap": "1.111111vh",
      "padding": "0.555556vh 0.925926vh",
      "border": "0",
      "borderRadius": "0.462963vh",
      "background": o.bg,
      "color": o.c,
      "cursor": "pointer",
      "font": "600 1.203704vh 'IBM Plex Mono',monospace",
      "whiteSpace": "nowrap",
      "textAlign": "left",
      "flex": "none"
    },
    className: "scapp-full-hover"
  }, React.createElement("span", {}, v.text(o.l)), React.createElement("span", {
    style: {
      "font": "1.018519vh 'IBM Plex Sans',sans-serif",
      "color": "#8793a6"
    }
  }, v.text(o.s))))))) : null)), v.text("\n            "), React.createElement("button", {
    "onClick": v.expDet.onClick,
    "title": v.expDet.title,
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.555556vh",
      "background": "rgba(20,38,62,0.6)",
      "border": "0.092593vh solid rgba(46,179,238,0.18)",
      "color": "#e4e9f0",
      "borderRadius": "0.555556vh",
      "padding": "0.37037vh 0.925926vh",
      "cursor": "pointer",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif",
      "whiteSpace": "nowrap",
      "flex": "none"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "1.203704vh",
      "lineHeight": "1"
    }
  }, v.text(v.expDet.icon)), v.text(v.expDet.label)), v.text("\n            "), React.createElement("button", {
    "onClick": v.goCmp,
    style: {
      "background": "#16213a",
      "border": "0.092593vh solid oklch(0.78 0.12 250)",
      "color": "#e4e9f0",
      "borderRadius": "0.555556vh",
      "padding": "0.37037vh 0.925926vh",
      "cursor": "pointer",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif",
      "whiteSpace": "nowrap"
    }
  }, v.text("Comparar días ›")), React.createElement("button", {
    "onClick": v.goDep,
    "title": v.depthTooltip || "Todas las jaulas y días por estrato",
    "aria-disabled": v.depthDisabled || undefined,
    "tabIndex": v.depthDisabled ? -1 : undefined,
    style: {
      "background": "#16213a",
      "border": "0.092593vh solid oklch(0.75 0.09 190)",
      "color": v.depthDisabled ? "#5a667a" : "#e4e9f0",
      "borderRadius": "0.555556vh",
      "padding": "0.37037vh 0.925926vh",
      "cursor": v.depthDisabled ? "not-allowed" : "pointer",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif",
      "whiteSpace": "nowrap"
    }
  }, v.text("Profundidad ›")), v.canExplainDay ? React.createElement(React.Fragment, null, React.createElement("button", {
    "onClick": v.goCz,
    "title": "¿Qué explica la pérdida en esta jaula?",
    style: {
      "background": "#16213a",
      "border": "0.092593vh solid oklch(0.72 0.16 350)",
      "color": "#e4e9f0",
      "borderRadius": "0.555556vh",
      "padding": "0.37037vh 0.740741vh",
      "cursor": "pointer",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif",
      "whiteSpace": "nowrap"
    }
  }, v.text("¿Por qué? ›"))) : null, v.text("\n            "), React.createElement("div", {
    style: {
      "display": "flex",
      "gap": "0.185185vh",
      "background": "rgba(3,10,22,0.6)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.555556vh",
      "padding": "0.185185vh",
      "alignItems": "center"
    }
  }, v.text("\n              "), React.createElement("button", {
    "onClick": v.panL,
    style: {
      "border": "0",
      "borderRadius": "0.37037vh",
      "padding": "0.277778vh 0.925926vh",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif",
      "cursor": "pointer",
      "background": "transparent",
      "color": v.panColor
    }
  }, v.text("‹")), v.text("\n              "), (v.zoomOpts || []).map((m, index18) => React.createElement(React.Fragment, {
    key: index18
  }, React.createElement("button", {
    "onClick": m.onClick,
    style: {
      "border": "0",
      "borderRadius": "0.37037vh",
      "padding": "0.277778vh 0.925926vh",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif",
      "cursor": "pointer",
      "background": m.bg,
      "color": m.color
    }
  }, v.text(m.label)))), v.text("\n              "), React.createElement("button", {
    "onClick": v.panR,
    style: {
      "border": "0",
      "borderRadius": "0.37037vh",
      "padding": "0.277778vh 0.925926vh",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif",
      "cursor": "pointer",
      "background": "transparent",
      "color": v.panColor
    }
  }, v.text("›")), v.text("\n            ")), v.text("\n          ")), v.text("\n        "));
}
